<template>
  <div class="form-group" :class="{ 'has-error': errors.has(name), 'form-group-active': active }">
    <label
      class="control-label"
      v-if="label">
      {{ label }}
    </label>
    <input
      ref="input"
      class="form-control"
      type="text"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      :data-vv-as="label"
      :required="required"
      v-mask="'##.###.###/####-##'"
      masked="true"
      v-validate="'cnpj'"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value),changeFocus()"
      @focus="changeFocus()"
    />
    <error-message :message="errors.first(name)"></error-message>
  </div>
</template>

<script>
import {isValid as isValidCNPJ} from '@fnando/cnpj';

export default {
  inject: ['$validator'],
  name: 'form-group-cnpj',
  props: {
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: String
  },

  data() {
    return {
      active: false
    };
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  created() {
    this.$validator.extend('cnpj', {
      getMessage: 'O CNPJ informado é inválido',
      validate: value => {
        return isValidCNPJ(value);
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupCnpj.vue